export enum ETipoPermiso {
  ADMINISTRADOR = 'ADMINISTRADOR',
  VENDEDOR = 'VENDEDOR',

  CLIENTE_CREAR = 'CLIENTE_CREAR',
  CLIENTE_EDITAR = 'CLIENTE_EDITAR',
  CLIENTE_ELIMINAR = 'CLIENTE_ELIMINAR',
  CLIENTE_VER_LISTA = 'CLIENTE_VER_LISTA',

  PRODUCTO_CREAR = 'PRODUCTO_CREAR',
  PRODUCTO_EDITAR = 'PRODUCTO_EDITAR',
  PRODUCTO_ELIMINAR = 'PRODUCTO_ELIMINAR',
  PRODUCTO_VER_LISTA = 'PRODUCTO_VER_LISTA',
  PRODUCTO_CREAR_INGRESO = 'PRODUCTO_CREAR_INGRESO',
  PRODUCTO_CREAR_SALIDA = 'PRODUCTO_CREAR_SALIDA',

  CATEGORIA_CREAR = 'CATEGORIA_CREAR',
  CATEGORIA_EDITAR = 'CATEGORIA_EDITAR',
  CATEGORIA_ELIMINAR = 'CATEGORIA_ELIMINAR',
  CATEGORIA_VER_LISTA = 'CATEGORIA_VER_LISTA',

  TIPO_PAGO_CREAR = 'TIPO_PAGO_CREAR',
  TIPO_PAGO_EDITAR = 'TIPO_PAGO_EDITAR',
  TIPO_PAGO_ELIMINAR = 'TIPO_PAGO_ELIMINAR',
  TIPO_PAGO_VER_LISTA = 'TIPO_PAGO_VER_LISTA',

  MOVIMIENTO_CAJA_CREAR = 'MOVIMIENTO_CAJA_CREAR',
  MOVIMIENTO_CAJA_EDITAR = 'MOVIMIENTO_CAJA_EDITAR',
  MOVIMIENTO_CAJA_ELIMINAR = 'MOVIMIENTO_CAJA_ELIMINAR',
  MOVIMIENTO_CAJA_VER_LISTA = 'MOVIMIENTO_CAJA_VER_LISTA',
  MOVIMIENTO_CAJA_OBTENER_REPORTE = 'MOVIMIENTO_CAJA_OBTENER_REPORTE',

  VENTA_CREAR = 'VENTA_CREAR',
  VENTA_EDITAR = 'VENTA_EDITAR',
  VENTA_ELIMINAR = 'VENTA_ELIMINAR',
  VENTA_VER_LISTA = 'VENTA_VER_LISTA',
  VENTA_OBTENER_REPORTE = 'VENTA_OBTENER_REPORTE',
  VENTA_A_CREDITO = 'VENTA_A_CREDITO',
  VENTA_A_CREDITO_VER_LISTA = 'VENTA_A_CREDITO_VER_LISTA',

  CAJA_TURNO_OBTENER_REPORTE = 'CAJA_TURNO_OBTENER_REPORTE',
  KARDEX_OBTENER_REPORTE = 'KARDEX_OBTENER_REPORTE',

  EMPLEADO_CREAR = 'EMPLEADO_CREAR',
  EMPLEADO_EDITAR = 'EMPLEADO_EDITAR',
  EMPLEADO_ELIMINAR = 'EMPLEADO_ELIMINAR',
  EMPLEADO_VER_LISTA = 'EMPLEADO_VER_LISTA',
  EMPLEADO_VER_LISTA_PERMISOS = 'EMPLEADO_VER_LISTA_PERMISOS',

  EDITAR_PRECIO_VENTA = 'EDITAR_PRECIO_VENTA',

  EMPRESA_EDITAR = 'EMPRESA_EDITAR',

  COMANDAS_CREAR = 'COMANDAS_CREAR',
  COMANDAS_VER = 'COMANDAS_VER',
  COMANDAS_EDITAR = 'COMANDAS_EDITAR',
  COMANDAS_ELIMINAR = 'COMANDAS_ELIMINAR',
  COMANDAS_ELIMINAR_PRODUCTOS = 'COMANDAS_ELIMINAR_PRODUCTOS',

  GESTOR_TIEMPO_CREAR = 'GESTOR_TIEMPO_CREAR',
  GESTOR_TIEMPO_EDITAR = 'GESTOR_TIEMPO_EDITAR',
  GESTOR_TIEMPO_ELIMINAR = 'GESTOR_TIEMPO_ELIMINAR',
  GESTOR_TIEMPO_VER_LISTA = 'GESTOR_TIEMPO_VER_LISTA',
  GESTOR_TIEMPO_ELIMINAR_PRODUCTOS = 'GESTOR_TIEMPO_ELIMINAR_PRODUCTOS',

  SUCURSAL_CREAR = 'SUCURSAL_CREAR',
  SUCURSAL_EDITAR = 'SUCURSAL_EDITAR',
  SUCURSAL_ELIMINAR = 'SUCURSAL_ELIMINAR',
  SUCURSAL_VER_LISTA = 'SUCURSAL_VER_LISTA',

  SUCURSAL_STOCK_TRANSFERIR = 'SUCURSAL_STOCK_TRANSFERIR',
  SUCURSAL_STOCK_INGRESAR_PRODUCTO = 'SUCURSAL_STOCK_INGRESAR_PRODUCTO',

  SESIONES_VER = 'SESIONES_VER',
  SESIONES_REVOCAR = 'SESIONES_REVOCAR',
}
